import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public useCORSProxy = false;

  get apiActivation() {
    return this.useCORSProxy ? 'proxyActivationAPI' : environment.apiActivation;
  }

  get api() {
    if (this.useCORSProxy) {
      if (!Capacitor.isNativePlatform()) {
        return 'proxyWebAPI';
      } else if (this.storageService.get('isRestrictedAccessAccount')) {
        return 'proxyExternalAPI';
      } else {
        return 'proxyAPI';
      }
    } else {
      if (!Capacitor.isNativePlatform()) {
        return 'https://p5.ekoemka.com.pl:8800';
      } else {
        return this.storageService.get('adresSerwera');
      }
    }
  }

  get newsFeedUrl() {
    // return this.useCORSProxy ? 'proxyNewsFeed' : 'https://ekoemka.com.pl/feed/';
    return 'https://ekoemka.com.pl/feed/';
  }

  get oilNewsFeedUrl() {
    return 'https://emkaoil.pl/feed/';
  }

  get adrNewsFeedUrl() {
    // return this.useCORSProxy ? 'proxyAdrNewsFeed' : 'https://ekoemka.com.pl/category/adr/feed/';
    return 'https://ekoemka.com.pl/category/adr/feed/';
  }

  constructor(private storageService: StorageService) {
    if (!Capacitor.isNativePlatform() && environment.useCORSProxy) {
      this.useCORSProxy = true;
    }
  }
}
